<template>
  <div class="contact-page">
    <nav-bar></nav-bar>
    <div class="page-1">
      <div class="title">CONTACT US</div>
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/CONTACT-1.png" alt="">
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/contect%20us-1.jpg" alt="" />
    </div>
    <div class="page_3_title">
      <div class="t1">DEALERS</div>
      <div class="t2">Current Dealers</div>
    </div>
    <div v-if="$isMobile" id="map"></div>
    <div class="page_3" v-if="$isMobile">
      <div v-for="(item,index) in dealerList" :key="index" class="dealer" :class="{ active: index == dealerIndex }"
        @click="changeDealer(item,index)">
        <div class="storeName">{{item.storeName}}</div>
        <div class="item">{{item.address}}</div>
        <div class="item">{{item.contactNumber}}</div>
        <div class="item">{{item.storeUrl}}</div>
      </div>
    </div>
    <div class="page_3" v-if="$isPC">
      <div class="left">
        <div v-for="(item,index) in dealerList" :key="index" class="dealer" @click="changeDealer(item,index)">
          <div class="inBox">
            <div class="storeName">{{item.storeName}}</div>
            <div class="item">{{item.address}}</div>
            <div class="item">{{item.contactNumber}}</div>
            <div class="item" style="color: #FFA400;">{{item.storeUrl}}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div id="map"></div>
      </div>
    </div>
    <div class="page-2">
      <div class="title">Become a dealer</div>
      <div class="tips" v-if="$isPC">Interested in being a distribution partner? <br /> please take a moment fill form
        below, we will get back to you shortly.</div>
      <div class="tips" v-else>Interested in being a distribution partner? please take a moment fill form below, we will
        get back to you shortly.</div>
      <el-form class="form" label-width="0px" ref="ruleForm" :model="ruleForm" :rules="rules">
        <el-form-item prop="firstName" class="item">
          <el-input placeholder="*First Name" v-model="ruleForm.firstName"></el-input>
        </el-form-item>
        <el-form-item prop="lastName" class="item">
          <el-input placeholder="*Last Name" v-model="ruleForm.lastName"></el-input>
        </el-form-item>
        <el-form-item prop="email" class="item">
          <el-input placeholder="*Email" v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item prop="storeUrl" class="item">
          <el-input placeholder="*storeUrl" v-model="ruleForm.storeUrl"></el-input>
        </el-form-item>
        <el-form-item prop="contactNumber" class="item">
          <el-input placeholder="*Contact Number" v-model="ruleForm.contactNumber"></el-input>
        </el-form-item>
        <el-form-item prop="storeName" class="item">
          <el-input placeholder="*Store Name" v-model="ruleForm.storeName"></el-input>
        </el-form-item>
        <el-form-item prop="companyName" class="item">
          <el-input placeholder="*Company Name" v-model="ruleForm.companyName"></el-input>
        </el-form-item>
        <el-form-item prop="storeAddress" class="item">
          <el-input placeholder="*Store Address" v-model="ruleForm.storeAddress"></el-input>
        </el-form-item>
        <el-form-item prop="state" class="item">
          <el-input placeholder="*State/Region" v-model="ruleForm.state"></el-input>
        </el-form-item>
        <el-form-item prop="country" class="item">
          <el-select placeholder="*Country" v-model="ruleForm.country" filterable clearable>
            <el-option v-for="item in countryList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="submit" @click="handleSubmit">Submit</div>
    </div>
    <footer-temp></footer-temp>
  </div>
</template>

<script>
  import footerTemp from '@/components/footer.vue'
  import NavBar from '@/components/navTab.vue'
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import markerIcon from '@/assets/images/marker_icon.png'
  import { getCountryList, getDealerList, submitDealerInfo } from '@/api/index'
  import Vue from 'vue'
  var map;
  var marker;

  // 防抖函数
  function debounce (func, wait) {
    let timeout;
    return function executedFunction (...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  export default {
    name: 'ContactPage',
    data () {
      return {
        showPopup: false,
        currentMarkerInfo: {},
        countryList: [],
        dealerList: [],
        ruleForm: {
          firstName: '',
          lastName: '',
          email: '',
          contactNumber: '',
          storeName: '',
          storeAddress: '',
          companyName: '',
          country: '',
          state: ''
        },
        rules: {
          firstName: [
            { required: true, message: 'Please input your first name', trigger: 'blur' }
          ],
          lastName: [
            { required: true, message: 'Please input your last name', trigger: 'blur' }
          ],
          email: [
            { required: true, message: 'Please input your email', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email', trigger: 'blur' }
          ],
          contactNumber: [
            { required: true, message: 'Please input your phone number', trigger: 'blur' },
          ],
          storeName: [
            { required: true, message: 'Please input your store name', trigger: 'blur' }
          ],
          storeAddress: [
            { required: true, message: 'Please input your store address', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: 'Please input your company name', trigger: 'blur' }
          ],
          country: [
            { required: true, message: 'Please select your country', trigger: 'change' }
          ],
          state: [
            { required: true, message: 'Please enter the state or city you are in', trigger: 'blur' }
          ]
        },
        map: null,
        onLineCar: null,
        markerList: [],
        dealerIndex: 0
      }
    },
    components: {
      NavBar,
      footerTemp
    },
    mounted () {
      // window.scrollTo(0, 0)
      this.initMap();
      this.getCountryListFn();
      this.getDealerListFn();

      // 创建防抖版本的提交方法
      this.debouncedSubmit = debounce(this.handleSubmitCore, 1000); // 1秒防抖
    },
    methods: {
      initMap () {
        // 初始化地图 
        this.map = L.map('map').setView([50.850346, 4.351721], 4);

        // 添加瓦片图层
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          minZoom: 3,
          maxZoom: 20,
          attribution: '&copy;  <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(this.map);

        // 创建经销商图标
        this.onLineCar = L.icon({
          iconUrl: markerIcon,
          iconSize: [30, 30],
          iconAnchor: [15, 15]
        });
      },
      // 添加marker
      addMarker (lat, lng, item) {
        const marker = L.marker([lat, lng], { icon: this.onLineCar }).addTo(this.map);
        marker._data = item;
        this.markerList.push(marker);
        // 添加点击marker时缩放到zoom 16
        marker.on('click', () => {
          this.map.setView([lat, lng], 16);
        });
        let popupVm = null
        this.markerList.forEach(item => {
          item.bindPopup('<div id="popup-vue"></div>')
          item.on('popupopen', () => {
            const _this = this;
            const res = item._data;
            popupVm = new Vue({
              render (h) {
                return h('div', { style: { display: 'flex', flexDirection: 'column', lineHeight: '16px' } }, [
                  h('div', { style: {} }, [
                    h('span', { style: { fontSize: '14px', fontWeight: 'bold' } }, 'Store Name: '),
                    h('span', { style: { fontSize: '13px', color: '#333' } }, res.storeName),
                  ]),
                  h('div', { class: 'p-item' }, [
                    h('span', { style: { fontSize: '14px', fontWeight: 'bold' } }, 'Store Address: '),
                    h('span', { style: { fontSize: '13px', color: '#333' } }, res.address),
                  ]),
                  h('div', { class: 'p-item' }, [
                    h('span', { style: { fontSize: '14px', fontWeight: 'bold' } }, 'Contact Number: '),
                    h('span', { style: { fontSize: '13px', color: '#333' } }, res.contactNumber),
                  ]),
                  h('div', { class: 'p-item' }, [
                    h('span', { style: { fontSize: '14px', fontWeight: 'bold' } }, 'Website Url: '),
                    h('span', { style: { fontSize: '13px', color: '#409EFF', cursor: 'pointer' }, on: { click: () => _this.openLink(res.storeUrl) } }, res.storeUrl),
                  ]),
                ])
              }
            }).$mount('#popup-vue')
          })
        })
        marker.on('popupclose', () => {
          popupVm && popupVm.$destroy()
          popupVm = null
        })
      },
      openLink (url) {
        const targetUrl = typeof url === 'string' ? url.trim() : '';
        if (!targetUrl) return;

        window.open(/^https?:\/\//i.test(targetUrl) ? targetUrl : `https://${targetUrl}`, '_blank', 'noopener,noreferrer');
      },
      // 获取经销商
      getDealerListFn () {
        getDealerList().then(res => {
          if (res.code === 200) {
            this.dealerList = res.data.map(item => ({
              ...item,
              lat: item.latitude,
              lng: item.longitude,
              address: item.storeAddress,
              storeUrl: item.storeUrl ? item.storeUrl : ''
            }));
            console.log('数据处理', this.dealerList);

            this.dealerList.forEach(item => {
              if (item.lat && item.lng) {
                this.addMarker(item.lat, item.lng, item)
              }
            })
            if (this.dealerList[0] && this.dealerList[0].lat && this.dealerList[0].lng) this.map.setView([this.dealerList[0].lat, this.dealerList[0].lng], 4);
          }
        })
      },
      changeDealer (item, index) {
        this.dealerIndex = index;
        this.map.setView([item.lat, item.lng], 16);
      },
      // 获取国家列表
      getCountryListFn () {
        getCountryList().then(res => {
          if (res.code === 200) {
            this.countryList = res.data;
          }
        })
      },
      // 防抖处理后的提交方法
      handleSubmit () {
        this.debouncedSubmit();
      },
      // 核心提交逻辑
      handleSubmitCore () {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            // 在提交前禁用按钮，防止重复点击
            const submitBtn = document.querySelector('.submit');
            if (submitBtn) {
              submitBtn.style.pointerEvents = 'none';
              submitBtn.style.opacity = '0.6';
            }

            submitDealerInfo(this.ruleForm).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: 'Success! Your information has been submitted.',
                  type: 'success',
                  customClass: 'my-custom-message'
                });
                this.$refs.ruleForm.resetFields();
              } else {
                this.$message.error(res.msg);
              }
            }).finally(() => {
              // 提交完成后重新启用按钮
              const submitBtn = document.querySelector('.submit');
              if (submitBtn) {
                submitBtn.style.pointerEvents = 'auto';
                submitBtn.style.opacity = '1';
              }
            })
          }
        })
      }
    }
  }
</script>
</script>

<style scoped lang="scss">
  img {
    display: block;
  }

  /* 去掉所有表单控件的圆角 */
  ::v-deep(.el-input__inner),
  ::v-deep(.el-select .el-input__inner),
  ::v-deep(.el-textarea__inner) {
    border-radius: 0 !important;
  }

  // 消除 label 占位
  ::v-deep(.el-form-item__label) {
    display: none !important;
  }

  @media (min-width: 769px) {

    .contact-page {
      position: relative;
      overflow: hidden;
      background: #000;

      .page-1 {
        width: 100%;        /* 用 100% 而非 100vw，避免含滚动条宽度导致横向滚动 */
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          flex: 1;
          color: #fff;
          font-family: "AlibabaPuHuiTi";
          font-size: 62.5px;
          font-weight: 900;
          padding-left: 100px;
          box-sizing: border-box;
        }

        img {
          position: relative;
          top: 100px;
          right: 100px;
        }
      }

      .page_3_title {
        font-family: "AlibabaPuHuiTi";
        background-color: #191919;
        /* PC 宽屏：标题左边界对齐 1440px 内容容器 */
        padding: 20px 0 10px max(177.77px, calc((100% - 1440px) / 2));
        box-sizing: border-box;

        .t1 {
          font-size: 33.33px;
          font-weight: 800;
          color: #FFA400;
        }

        .t2 {
          font-size: 16.66px;
          font-weight: 500;
          color: #fff;
        }
      }

      .page_3 {
        font-family: "AlibabaPuHuiTi";
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        max-width: 1440px;
        margin: 0 auto;

        .left {
          width: 40%;
          color: #fff;
          height: 500px;
          overflow: auto;

          /* 整个滚动条 */
          &::-webkit-scrollbar {
            width: 6px;
            /* 滚动条宽度 */
          }

          /* 滚动条轨道 */
          &::-webkit-scrollbar-track {
            background: #0a0a0a;
            /* 深色背景 */
          }

          /* 滚动条滑块 */
          &::-webkit-scrollbar-thumb {
            background: #FFA400;
            /* 黄色（金色） */
            border-radius: 4px;
          }

          .dealer {
            /* font-family: "AlibabaPuHuiTi"; */
            color: #fff;
            border-bottom: 1px solid #333333;
            box-sizing: border-box;
            cursor: pointer;

            .inBox {
              padding: 15px 20px 15px max(0px, calc(177.77px - max(0px, (100vw - 1440px) / 2)));
              width: 100%;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
            }

            .storeName {
              font-size: 33px;
              font-weight: 500;
            }

            .item {
              font-size: 16px;
              font-weight: 500;
              color: rgba(255, 255, 255, .9);
            }
          }

          .active {
            background: #191919;
          }
        }

        .right {
          flex: 1;
          /* padding-right: 94px; */
          box-sizing: border-box;

          #map {
            width: 100%;
            height: 500px;

            ::v-deep #popup-vue {
              width: 450px;
            }

            /* popup 容器 */
            ::v-deep .leaflet-popup-content {
              margin: 8px 10px;
              /* 减小默认边距 */
            }
          }
        }
      }

      .page-2 {
        background-color: #191919;
        /* PC 宽屏：背景全宽，表单内容压在 1440px 内居中 */
        padding: 50px max(177.77px, calc((100% - 1440px) / 2));

        .title {
          font-family: "AlibabaPuHuiTi";
          font-size: 34.72px;
          font-weight: 800;
          color: #FFA400;
        }

        .tips {
          font-size: 18.05px;
          font-family: "AlibabaPuHuiTi";
          font-weight: 500;
          color: #fff;
          margin: 30.55px 0;
        }

        .form {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          box-sizing: border-box;
          gap: 13.88px;
          position: relative;
          left: -10px;

          .item {
            flex: 1 1 calc(50% - 13.88px);
            height: 36px;
            border: none;
            font-size: 13.88px;
            text-indent: 10px;
            margin-bottom: 10px;

            .el-select {
              width: 100%;
            }
          }

          .address_box {
            display: flex;
            gap: 14px;

            .address {
              flex: 1;
            }
          }
        }

        .submit {
          text-align: center;
          font-size: 27.77px;
          color: #fff;
          background: #FFA400;
          margin-top: 33.33px;
          cursor: pointer;
          padding: 5px 0;
          font-family: "AlibabaPuHuiTi";
          font-weight: 500;
        }
      }

      .page-3 {
        color: #fff;
        font-size: 275.69px;
        padding: 33.33px 0;
        text-align: center;
        background-color: #000000;
      }

      .page-4 {
        width: 100%;
        height: 80vh;
        box-sizing: border-box;
        text-align: center;
        z-index: 999;
      }

      ::v-deep .leaflet-control-attribution {
        font-size: 12px;
        /* 调整 attribution 字体大小 */
      }

    }

    /* 添加过渡动画样式 */
    .popup-fade-enter-active {
      transition: all 0.3s ease-out;
    }

    .popup-fade-leave-active {
      transition: all 0.3s ease-in;
    }

    .popup-fade-enter-from {
      opacity: 0;
      transform: translateY(-20px);
    }

    .popup-fade-leave-to {
      opacity: 0;
      transform: translateY(-20px);
    }

    .popup {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;        /* fixed 下 100% = 视口宽且不含滚动条，避免横向溢出 */
      height: 100vh;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, .5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;

      .popup-content {
        background: #EDEDED;
        padding: 20px;
        min-width: 400px;
        position: relative;
        box-sizing: border-box;

        .close {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 15px;
          height: 15px;
          cursor: pointer;
        }

        .title {
          font-size: 12.5px;
          font-weight: bold;
          margin-bottom: 15px;
          text-align: center;
        }

        .form {
          display: flex;
          flex-direction: column;
          row-gap: 10px;

          .item {
            display: flex;
            align-items: center;
            background-color: #fff;
            padding: 6px 8px;

            img {
              margin-right: 10px;
              width: 15px;
              height: 15px;
            }

            span {
              font-size: 14px;
            }
          }
        }
      }
    }

    ::v-deep .leaflet-touch .leaflet-bar a {
      width: 20px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
    }
  }

  @media (max-width: 768px) {
    .contact-page {
      position: relative;
      overflow: hidden;
      background: #000;

      .page-1 {
        width: 100vw;
        position: relative;

        .title {
          width: 100%;
          height: auto;
          position: absolute;
          top: 20%;
          left: 0;
          text-align: center;
          color: #fff;
          font-family: "AlibabaPuHuiTi";
          font-size: 32px;
          font-weight: 900;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }

      .page_3_title {
        width: 100%;
        text-align: center;
        background-color: #191919;
        font-family: "AlibabaPuHuiTi";
        padding: 10px 0;

        .t1 {
          font-size: 18px;
          color: #FFA400;
          font-weight: 900;
        }

        .t2 {
          font-size: 8px;
          color: #fff;
          font-weight: 500;
        }
      }

      #map {
        width: 100%;
        height: 300px;

        ::v-deep #popup-vue {
          width: 450px;
        }

        /* popup 容器 */
        ::v-deep .leaflet-popup-content {
          margin: 8px 10px;
          /* 减小默认边距 */
        }
      }

      .page_3 {
        width: 100%;
        height: 300px;
        overflow: auto;
        text-align: center;

        .dealer {
          width: 100%;
          border-bottom: 1px solid #191919;
          color: #fff;
          line-height: 17px;
          padding: 10px 0;

          .storeName {
            font-size: 17px;
          }

          .item {
            font-size: 8px;

            &:last-child {
              color: #FFA400;
            }
          }

        }

        .active {
          background-color: #191919;
        }
      }

      .page-2 {
        padding: 16px 20px;
        box-sizing: border-box;
        text-align: center;
        background-color: #191919;

        .title {
          font-size: 22px;
          text-align: center;
          font-family: "AlibabaPuHuiTi";
          font-weight: 900;
          color: #FFA400;
        }

        .tips {
          font-size: 10px;
          font-family: "AlibabaPuHuiTi";
          color: #fff;
          margin: 10px 0;
        }

        .form {
          display: flex;
          flex-direction: column;
          row-gap: 16px;

          .el-form-item {
            border: none;
            font-size: 12px;
            margin-bottom: 4px;

            .el-select {
              width: 100%;
            }
          }
        }

        .submit {
          width: 100%;
          padding: 6px 0;
          background-color: #FFA400;
          color: #fff;
          font-size: 14px;
          font-family: "AlibabaPuHuiTi";
          margin-top: 16px;
        }
      }

      .page-3 {
        font-size: 75px;
        background-color: #000000;
        color: #fff;
        text-align: center;
      }

      .page-4 {
        width: 100vw;
        height: 30vh;
      }

      ::v-deep .leaflet-control-attribution {
        font-size: 12px;
        /* 调整 attribution 字体大小 */
      }
    }

    .popup {
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, .5);
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;

      .popup-content {
        position: relative;
        min-width: 90vw;
        background-color: #EDEDED;
        padding: 16px;
        box-sizing: border-box;

        .close {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 15px;
          height: 15px;
        }

        .title {
          font-size: 12.5px;
          text-align: center;
          color: #333333;
          font-family: Tilt Warp;
        }

        .form {
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          margin-top: 15px;

          .item {
            display: flex;
            align-items: center;
            column-gap: 5px;
            background-color: #fff;
            padding: 8px 10px;

            img {
              width: 15px;
              height: 15px;
            }

            span {
              color: #333333;
            }
          }
        }
      }
    }
  }
</style>